import { CustomCartItem } from './../../../models/custom-cart-item.model';
import { APP } from '@/constants/app.constant';
import { CustomShopOrder } from './../../../models/custom-shop-order.model';
import { CustomResponse } from '@/models/custom-response.model';
import { Component, Vue } from 'vue-property-decorator';
import { CustomBusiness } from '@/models/custom-business.model';
import { BusinessService, OrderService } from '@/services';
import { namespace } from 'vuex-class';
import PayPal from 'vue-paypal-checkout';

const Notification = namespace('notification');

@Component({
    components: {
        PayPal,
    },
})
export default class LollyView extends Vue {
    @Notification.Action('addSuccess') private addSuccess: any;
    @Notification.Action('addError') private addError: any;

    public inFlight: boolean = false;
    public business: CustomBusiness = null;
    public order: CustomShopOrder = null;
    public optIn: boolean = false;

    public credentials: any = APP.PAYPAL_CREDENTIALS;
    public environment: any = APP.PAYPAL_ENVIRONMENT;
    public inTransaction: boolean = false;
    public itemPrice: number = 10;
    public total: string = '10';
    public itemList: any[] = null;
    public buttonStyles: any = {
        label: 'checkout',
        size: 'medium',
        shape: 'rect',
        color: 'gold',
    };

    public mounted(): void {
        this.getData(this.$route.params.slug);
    }

    get shippingCosts(): number {
        return this.getOrderAmount() > 1 ? 4.99 : 2.35;
    }

    private async getData(slug) {
        this.inFlight = true;
        try {
            const response = await BusinessService.publicGet(slug);
            this.business = response.data;
            this.inFlight = false;
            document.title = 'Unterstützen: ' + this.business.name;

            // create order
            this.order = new CustomShopOrder({
                country: 'Deutschland',
                shop_cart_items: [
                    {
                        business_id: this.business.id,
                        shop_product_id: 1,
                        amount: 1,
                    },
                ],
            });
        } catch (error) {
            console.error('DetailView::getData – failed to business by slug: ', this.$route.params.slug);
            this.inFlight = false;
        }
    }

    public getOrderAmount() {
        return  this.order
                && this.order.shop_cart_items
                && this.order
                && this.order.shop_cart_items.length
                && this.order.shop_cart_items[0].amount
                || 0;
    }

    public setOrderAmount(newAmount) {
        const setWith = newAmount >= 2 ? newAmount : 1;

        if (
            this.order
            && this.order.shop_cart_items
            && this.order.shop_cart_items.length
        ) {
            this.order.shop_cart_items[0].amount = parseInt(setWith, 10);
        }
    }

    public createOrder() {
        this.inTransaction = true;
        OrderService.create(this.order)
            .then(
                (response: CustomResponse<CustomShopOrder>) => {
                    this.inTransaction = false;
                    this.addSuccess(response.localized);
                    this.order = response.data;


                    let totalAmount = this.order.shop_cart_items.reduce((prev, curr) => {
                        prev += curr.amount * this.itemPrice;
                        return prev;
                    }, 0);
                    totalAmount += this.shippingCosts;
                    this.total = `${totalAmount}`;


                    this.itemList = [
                        ...this.order.shop_cart_items.map((item: CustomCartItem) => {
                            return {
                                name: `Localoolly`,
                                description: `Hiermit unterstützt du das Unternehmen: '${this.business.name}'`,
                                price: `${this.itemPrice}`,
                                quantity: `${item.amount}`,
                                currency: `EUR`,
                            };
                        }),
                        {
                            name: `Versand`,
                            description: `Versandkosten`,
                            price: `${this.shippingCosts}`,
                            quantity: `1`,
                            currency: `EUR`,
                        },
                    ];
                },
                (error) => {
                    this.addError(error.localized, error);
                    this.inTransaction = false;
                },
            );
    }

    public canSubmit() {
        if (!this.optIn) {
            return false;
        }

        if (
            this.order.first_name.length <= 2
            || this.order.last_name.length <= 2
            || this.order.email.length <= 2
            || this.order.address.length <= 2
            || this.order.postal.length <= 2
            || this.order.city.length <= 2
            || this.order.country.length <= 1
        ) {
            return false;
        }

        return true;
    }

    public paymentAuthorized(data) {
        // console.log('auth', data);
    }

    public paymentCompleted(data) {
        this.inTransaction = true;

        OrderService.setPayment(this.order.id, data.cart)
            .then(
                (response: CustomResponse<CustomShopOrder>) => {
                    console.log('updated');
                    this.order = new CustomShopOrder({
                        shop_cart_items: [
                            {
                                business_id: this.business.id,
                                shop_product_id: 1,
                                amount: 1,
                            },
                        ],
                    });
                    this.inTransaction = false;
                    this.$router.push({ name: 'publicDetailThankYou' });
                },
                (error) => {
                    console.error('update failed');
                    this.addError(error.localized, error);
                    this.inTransaction = false;
                },
            );
    }

    public paymentCancelled(data) {
        // console.log('canc', data);
    }

    public formatPrice(value) {
        const val = (value / 1).toFixed(2).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    public scrollMeTo(refName) {
        const element = this.$refs[refName] as HTMLElement;
        const top = element.offsetTop;

        window.scrollTo(0, top);
    }
}
